import React, { PropTypes } from 'react'
import classnames from 'classnames'
import CSSModules from 'react-css-modules'
import { Link } from 'react-router'

import Dropdown from 'components/dropdown'
import preventDefault from 'utils/prevent-default'

import styles from './sub-navigation.css'

import LogoIcon from '../../../assets/icons/to-logo-white.svg'
import UserIcon from '../../../assets/icons/user.svg'

const SubNavigation = ({ dropdownOpen, items, homeLink, onUserClick, onModalClick }) => (
  <div styleName="sub-navigation">

    <a href={homeLink} styleName="logo">
      <LogoIcon styleName="logo-icon" />
    </a>

    <div styleName="user">
      {dropdownOpen &&
        <div styleName="dropdown">
          <Dropdown overlay direction="top-right">
            <ul styleName="list">
              {items.map((item, index) => (
                <li
                  key={index} // eslint-disable-line react/no-array-index-key
                  styleName="item"
                >
                  {!item.external ?
                    <Link
                      to={item.path || '/'}
                      styleName={classnames('link', {
                        'normal-link': !item.staffOnly,
                        'staff-only-link': item.staffOnly,
                      })}
                      onClick={item.modal && preventDefault(() => onModalClick(item.modal))}
                    >
                      {item.label}
                    </Link>
                  :
                    <a
                      href={item.path || '/'}
                      styleName={classnames('link', {
                        'normal-link': !item.staffOnly,
                        'staff-only-link': item.staffOnly,
                      })}
                      onClick={item.modal && preventDefault(() => onModalClick(item.modal))}
                    >
                      {item.label}
                    </a>
                  }
                </li>
              ))}
            </ul>
          </Dropdown>
        </div>
      }
      <UserIcon styleName="userIcon" onClick={onUserClick} />
    </div>

  </div>
)

SubNavigation.propTypes = {
  dropdownOpen: PropTypes.bool,
  homeLink: PropTypes.string,
  items: PropTypes.array,
  onModalClick: PropTypes.func,
  onUserClick: PropTypes.func,
}

export default CSSModules(SubNavigation, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/sub-navigation/sub-navigation.js
 **/